module.exports = __webpack_public_path__ + "static/media/8.7629f29c.PNG";